import Vue from 'vue'
import VueRouter from 'vue-router'
import caches from '@/utils/cache'
import authorityPath from './authorityPath'
Vue.use(VueRouter)

let originPush = VueRouter.prototype.push

let originReplace = VueRouter.prototype.replace

VueRouter.prototype.push = function (location, resolve, reject) {
  if (resolve && reject) {
    originPush.call(this, location, resolve, reject)
  } else {
    originPush.call(
      this,
      location,
      () => {},
      () => {}
    )
  }
}

VueRouter.prototype.replace = function (location, resolve, reject) {
  if (resolve && reject) {
    originReplace.call(this, location, resolve, reject)
  } else {
    originReplace.call(
      this,
      location,
      () => {},
      () => {}
    )
  }
}

const routes = [
  {
    path: '/',
    redirect: '/home'
  },
  {
    path: '/home',
    name: 'home',
    meta: {
      title: '首页'
    },
    component: () => import(/* webpackChunkName: "home" */ '@/views/home/index.vue')
  },
  // {
  //   path: '/login',
  //   name: 'login',
  //   meta: {
  //     title: '登录'
  //   },
  //   component: () => import(/* webpackChunkName: "login" */ '@/views/login/index.vue')
  // },
  {
    path: '/scenic-overview',
    name: 'scenic-overview',
    meta: {
      title: '景区总览'
    },
    component: () => import(/* webpackChunkName: "scenic-overview" */ '@/views/scenic-overview/index.vue')
  },
  {
    path: '/scenic-overview/tourist-server',
    name: 'scenic-overview-tourist-server',
    meta: {
      title: '游客服务'
    },
    component: () => import(/* webpackChunkName: "scenic-overview-tourist-server" */ '@/views/scenic-overview/tourist-server.vue')
  },
  {
    path: '/scenic-overview/news',
    name: 'scenic-overview-news',
    meta: {
      title: '景区资讯'
    },
    component: () => import(/* webpackChunkName: "scenic-overview-news" */ '@/views/scenic-overview/scenic-news.vue')
  },
  {
    path: '/detail-info',
    name: 'detail-info',
    meta: {
      title: '详情内容'
    },
    component: () => import(/* webpackChunkName: "detail-info" */ '@/views/detail/index.vue')
  },
  {
    path: '/scenic-overview/media',
    name: 'scenic-overview-media',
    meta: {
      title: '景区信息'
    },
    component: () => import(/* webpackChunkName: "scenic-overview-media" */ '@/views/scenic-overview/scenic-media.vue')
  },
  {
    path: '/scenic-media-detail',
    name: 'scenic-media-detail',
    meta: {
      title: '影音详情'
    },
    component: () => import(/* webpackChunkName: "scenic-media-detail" */ '@/views/scenic-overview/scenic-media-detail.vue')
  },
  {
    path: '/best-wawu',
    name: 'best-wawu',
    meta: {
      title: '最美瓦屋'
    },
    component: () => import(/* webpackChunkName: "best-wawu" */ '@/views/best-wawu/index.vue')
  },
  {
    path: '/play-wawu',
    name: 'play-wawu',
    meta: {
      title: '玩转瓦屋'
    },
    component: () => import(/* webpackChunkName: "play-wawu" */ '@/views/play-wawu/index.vue')
  },
  {
    path: '/play-wawu/list',
    name: 'play-wawu-list',
    meta: {
      title: '玩转瓦屋列表'
    },
    component: () => import(/* webpackChunkName: "play-wawu-list" */ '@/views/play-wawu/play-list.vue')
  },
  {
    path: '/activity',
    name: 'activity',
    meta: {
      title: '活动盛典'
    },
    component: () => import(/* webpackChunkName: "activity" */ '@/views/activity/index.vue')
  },
  {
    path: '/explore-scenic/actual-scenic',
    name: 'actual-scenic',
    meta: {
      title: '实时风景'
    },
    component: () => import(/* webpackChunkName: "actual-scenic" */ '@/views/explore-scenic/actual-scenic.vue')
  },
  {
    path: '/explore-scenic/scenic-guide',
    name: 'scenic-guide',
    meta: {
      title: '景区导览'
    },
    component: () => import(/* webpackChunkName: "scenic-guide" */ '@/views/explore-scenic/scenic-guide.vue')
  },
  {
    path: '/talk-center',
    name: 'talk-center',
    meta: {
      title: '交流中心'
    },
    component: () => import(/* webpackChunkName: "talk-center" */ '@/views/talk-center/index.vue')
  },
  {
    path: '/talk-center/notice-list',
    name: 'notice-list',
    meta: {
      title: '公示公告'
    },
    component: () => import(/* webpackChunkName: "notice-list" */ '@/views/talk-center/notice-list.vue')
  },
  {
    path: '/talk-center/publish-msg-result',
    name: 'publish-msg-result',
    meta: {
      title: '发布结果'
    },
    component: () => import(/* webpackChunkName: "publish-msg-result" */ '@/views/talk-center/publish-msg-result.vue')
  },
  {
    path: '/talk-center/publish-msg',
    name: 'publish-msg',
    meta: {
      title: '发布留言'
    },
    component: () => import(/* webpackChunkName: "publish-msg" */ '@/views/talk-center/publish-msg.vue')
  },
  {
    path: '/talk-center/publish-step/:step',
    name: 'publish-step',
    meta: {
      title: '发布内容'
    },
    component: () => import(/* webpackChunkName: "publish-step" */ '@/views/talk-center/publish-step.vue')
  },
  {
    path: '/talk-center/travel-square',
    name: 'travel-square',
    meta: {
      title: '游记广场'
    },
    component: () => import(/* webpackChunkName: "travel-square" */ '@/views/talk-center/travel-square.vue')
  },
  {
    path: '/personal',
    name: 'personal',
    meta: {
      title: '个人中心'
    },
    component: () => import(/* webpackChunkName: "personal" */ '@/views/personal/index.vue')
  },
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  window.scrollTo(0, 0)
  next()

  if(authorityPath(to.path) && !caches.getCache('token')){
    next('/home')
  } else {
    next()
  }
})

export default router
